var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"450","loading":"lazy","allowfullscreen":"","referrerpolicy":"no-referrer-when-downgrade","src":`https://www.google.com/maps/embed/v1/place?key=AIzaSyDVygkMvXf52_ayQWgsn5ECFerpRkIEivY
  &q=Juba+Mall+Supermaket,Juba`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }